import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconEnvelope16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconEnvelope16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M13 3H3a1 1 0 0 0-.51.14l5.516 5.517 5.512-5.512A1 1 0 0 0 13 3M2 11.763V4.065l3.85 3.849zm.387 1.027c.17.132.382.21.613.21h10c.234 0 .449-.08.62-.215L9.455 8.622 8.36 9.718l-.354.353-.353-.353L6.556 8.62zm7.776-4.875L14 11.752V4.077zm4.73 4.73c.07-.202.107-.42.107-.645V4a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 1.892-1.351l.003-.002z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconEnvelope16);
